import Swiper from 'swiper'
import { Navigation, Pagination, Autoplay } from 'swiper/modules'
import 'swiper/css'
class Guide {
  constructor() {
    this.swiper()
  }
  swiper() {
    try {
      const swiper = new Swiper('#guide .swiper', {
        pagination: {
          el: '#guide .swiper-pagination',
        },
        modules: [Navigation, Pagination, Autoplay],
        autoplay: {
          delay: 3500
        },
        loop: true,
        navigation: {
          nextEl: '#guide .swiper-button-next',
          prevEl: '#guide .swiper-button-prev'
        },
        autoHeight: true,

      })

    } catch (error) {
      console.log('Guide.swiper', { message: error.message })
    }
  }

}
export default window.addEventListener('DOMContentLoaded', () => {
  new Guide()
})